import {
  getDownloadUrlForDocument,
  useUpdateUserDocument,
  useUserFiles,
} from "@coaching-culture/api-client";
import { UserAttachedDocumentDto } from "@coaching-culture/types";
import {
  Box,
  FormInput,
  FormInputWrap,
  FormTextArea,
  Loader,
  Modal,
  PanelHeader,
  NewFileUploader,
  Button,
  Flex,
  Text,
  Tabs,
  TabPane,
  DatePill,
  UserFlag,
  MultilineText,
} from "@coaching-culture/ui";
import { useUser } from "auth";
import { useEffect, useState } from "react";
import { FaDownload } from "react-icons/fa";

export type EditDocumentModalProps = {
  userId: string;
  documentId: string;
  onClose: () => void;
};

const Info = ({
  doc,
  userId,
}: {
  doc: UserAttachedDocumentDto;
  userId: string;
}) => {
  const download = async () => {
    const url = await getDownloadUrlForDocument(userId, doc.id);

    window.location.replace(url);
  };

  return (
    <>
      <Box mb={2}>
        <Text fontWeight={600} color="grey2">
          Name
        </Text>
        <Text>{doc.name}</Text>
      </Box>
      <Box mb={2}>
        <Text fontWeight={600} color="grey2">
          Description
        </Text>
        <MultilineText>{doc.description || "<None>"}</MultilineText>
      </Box>
      <Box mb={2}>
        <Text fontWeight={600} color="grey2">
          Uploaded By
        </Text>
        <UserFlag user={doc.uploader} />
      </Box>

      <Box mb={5}>
        <Text fontWeight={600} color="grey2">
          Created
        </Text>
        <DatePill value={doc.uploadedAt} />
      </Box>
      <Button icon={FaDownload} onClick={download}>
        Download
      </Button>
    </>
  );
};

export const EditDocumentModal = ({
  userId,
  documentId,
  onClose,
}: EditDocumentModalProps) => {
  const [name, setName] = useState("");
  const [des, setDes] = useState("");
  const [file, setFile] = useState<null | string>(null);
  const [me] = useUser();

  const files = useUserFiles(userId);
  const updateMut = useUpdateUserDocument();

  const doc = files.data?.find((x) => x.id === documentId);

  useEffect(() => {
    setName(doc?.name ?? "");
    setDes(doc?.description ?? "");
  }, [doc]);

  const update = async () => {
    await updateMut.mutateAsync({
      id: documentId,
      userId: userId,
      name: name,
      description: des,
      fileId: file,
    });
    onClose();
  };

  const isUploader = me.id === doc?.uploader.id;

  return (
    <Modal onClose={onClose} showCloseButton width={500}>
      <PanelHeader>
        <Text fontWeight={600}>Document</Text>
      </PanelHeader>
      {doc == null ? (
        <Loader />
      ) : (
        <Box p={3}>
          {isUploader ? (
            <Tabs size="small">
              <TabPane defaultValue={"Information"}>
                <Info doc={doc} userId={userId} />
              </TabPane>
              <TabPane defaultValue={"Edit"}>
                <FormInput
                  label="Name"
                  value={name}
                  onChange={(ev) => setName(ev.target.value)}
                />
                <FormTextArea
                  label="description"
                  value={des}
                  onChange={(ev) => setDes(ev.target.value)}
                  height={150}
                />
                <FormInputWrap label="File" mb={5}>
                  <NewFileUploader onChange={(val) => setFile(val.fileId)} />
                </FormInputWrap>
                <Flex style={{ gap: 6 }}>
                  <Button onClick={update} color="primary">
                    Save
                  </Button>
                  <Button onClick={onClose}>Cancel</Button>
                </Flex>
              </TabPane>
            </Tabs>
          ) : (
            <Info doc={doc} userId={userId} />
          )}
        </Box>
      )}
    </Modal>
  );
};
